export const PROJECT_CONST = {
    GET_PROJECT: "GET_PROJECT",
    GET_PROJECT_BY_ID: "GET_PROJECT_BY_ID",
}